import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { Swiper, Slide } from 'react-dynamic-swiper';
import 'react-dynamic-swiper/lib/styles.css';
import { CROSS_LARGE, ARROW_DOWN } from '../../constants/iconNames';
import Icon from '../../icons';
import Variables from '../../styles/variables.scss';
import './imageViewer.scss';
export default function ExtendedImage({ expandedIndex, imagesFiles, toggleExpandImage }) {
    const icon = className => (_jsx("span", { className: className, children: _jsx(Icon, { name: ARROW_DOWN, stroke: Variables.whiteSecondary, width: "30px", height: "30px" }) }));
    const sortedImagesFiles = () => {
        if (!expandedIndex) {
            return imagesFiles;
        }
        const startValues = imagesFiles.slice(expandedIndex);
        const endValues = imagesFiles.slice(0, expandedIndex);
        return startValues.concat(endValues);
    };
    return (_jsxs("div", { className: "image_file__expanded", children: [_jsx("button", { onClick: toggleExpandImage, children: _jsx(Icon, { fill: Variables.whiteSecondary, name: CROSS_LARGE }) }), _jsx(Swiper, { swiperOptions: {
                    slidesPerView: 'auto',
                    loop: sortedImagesFiles().length > 1,
                    pagination: false,
                }, nextButton: () => icon('navigation-arrow--next'), prevButton: () => icon('navigation-arrow--prev'), children: sortedImagesFiles().map((item, index) => (_jsx(Slide, { id: index, children: _jsx("img", { alt: "added item", src: item.file }, item.fileName) }, item))) })] }));
}
ExtendedImage.propTypes = {
    expandedIndex: PropTypes.number.isRequired,
    imagesFiles: PropTypes.arrayOf(PropTypes.any).isRequired,
    toggleExpandImage: PropTypes.func.isRequired,
};
